import * as React from 'react'

import { Props } from '../../containers/landingPageContainer'

/* eslint-disable react/no-danger */
const LandingPage = ({ html, css }: Props) => {
  return (
    <div className="landing-page-content">
      {css && <style>{css}</style>}
      <div
        className="landing-page-body"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  )
}

export default LandingPage
